import React from "react"
import ReactDOM from "react-dom"
import QuoteStatementComponent from "./quote-statement-component"

export default class EpiVideoModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<QuoteStatementComponent {...this.modelJson} />, self.elem)
  }
}
